import type {NotificationItem} from "../types";

export function getNotificationSubjectPath(item: NotificationItem): string {
  if (item.topic === "stored_vehicle") {
    const vehicleId =
      typeof item.payload.vehicle_id === "number" ? item.payload.vehicle_id : null;

    if (vehicleId) {
      return `/parking-enforcement/${vehicleId}?tab=stored-vehicles`;
    }

    const storedVehicleId =
      typeof item.payload.stored_vehicle_id === "number"
        ? item.payload.stored_vehicle_id
        : typeof item.subject.id === "number"
          ? item.subject.id
          : null;

    if (storedVehicleId) {
      return `/stored-vehicles`;
    }
  }

  if (item.topic === "shift") {
    return "/home";
  }

  if (item.topic === "household") {
    return "/";
  }

  if (item.topic === "direct_message") {
    const threadId =
      typeof item.payload.direct_message_thread_id === "number"
        ? item.payload.direct_message_thread_id
        : typeof item.subject.id === "number"
          ? item.subject.id
          : null;

    if (threadId) {
      return `/direct-messages?thread=${threadId}`;
    }
  }

  if (item.topic === "briefing_board" || item.payload.briefing_board_id != null) {
    const briefingBoardId =
      typeof item.payload.briefing_board_id === "number"
        ? item.payload.briefing_board_id
        : item.topic === "briefing_board" && typeof item.subject.id === "number"
          ? item.subject.id
          : null;

    if (briefingBoardId) {
      const shiftId =
        typeof item.payload.shift_id === "number"
          ? item.payload.shift_id
          : null;

      if (shiftId) {
        return `/briefings?brief=${briefingBoardId}&shift=${shiftId}`;
      }

      return `/briefings?brief=${briefingBoardId}`;
    }
  }

  return "/notifications";
}
